import { render, staticRenderFns } from "./PostSidebar.vue?vue&type=template&id=a7e387e2"
import script from "./PostSidebar.vue?vue&type=script&lang=js"
export * from "./PostSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7e387e2')) {
      api.createRecord('a7e387e2', component.options)
    } else {
      api.reload('a7e387e2', component.options)
    }
    module.hot.accept("./PostSidebar.vue?vue&type=template&id=a7e387e2", function () {
      api.rerender('a7e387e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/PostSidebar.vue"
export default component.exports